import { render, staticRenderFns } from "./EnableDisableModifierModal.vue?vue&type=template&id=96c9e2ba&scoped=true"
import script from "./EnableDisableModifierModal.vue?vue&type=script&lang=ts"
export * from "./EnableDisableModifierModal.vue?vue&type=script&lang=ts"
import style0 from "./EnableDisableModifierModal.vue?vue&type=style&index=0&id=96c9e2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c9e2ba",
  null
  
)

export default component.exports